module.exports = __webpack_public_path__ + "project-content-media-stick.png";